import { useState, useEffect, useContext } from 'react'
import authService from '../api-authorization/AuthorizeService';

const AuthorizeComponent = async (roles) => {
    const isAuth = await authService.isAuthorized(roles);
    return isAuth;
}
export default AuthorizeComponent;